<template>
   <b-modal id="modalManageCategories" modal-class="modal-fullscreen" title="Categorieën beheren" hide-backdrop
      size="md" scrollable
      @show="focusInput"
      hide-footer>
      <p class="text-muted small">
         Kies categorieën uit deze lijst bij ingrediënten en boodschappen, zodat ze op de
         boodschappenlijst netjes samenvallen (geen dubbele rijen door hoofdletters of typo's).
      </p>

      <!-- Nieuwe categorie toevoegen -->
      <b-form @submit.stop.prevent="addCategory" class="mb-3">
         <b-input-group>
            <b-form-input ref="inputNaam"
               v-model="newCategoryName"
               placeholder="Nieuwe categorie (bijv. Groente)"
               :state="newCategoryValid" />
            <b-input-group-append>
               <b-button type="submit" variant="primary" :disabled="newCategoryValid !== true">
                  <b-icon icon="plus" /> Toevoegen
               </b-button>
            </b-input-group-append>
         </b-input-group>
         <b-form-invalid-feedback :state="newCategoryValid">{{ newCategoryInvalidInfo }}</b-form-invalid-feedback>
      </b-form>

      <!-- Categorie-lijst -->
      <b-list-group flush>
         <b-list-group-item v-for="row in rows" :key="row.id"
            class="d-flex justify-content-between align-items-center py-2 px-1">
            <template v-if="editingId === row.id">
               <b-form-input v-model="editingName" size="sm" class="mr-2"
                  @keydown.enter.prevent="saveEdit" />
               <div class="text-nowrap">
                  <b-button size="sm" variant="success" class="mr-1" @click="saveEdit">
                     <b-icon icon="check" />
                  </b-button>
                  <b-button size="sm" variant="secondary" @click="cancelEdit">
                     <b-icon icon="x" />
                  </b-button>
               </div>
            </template>
            <template v-else>
               <span>{{ row.naam }}
                  <b-badge v-if="!row.local" variant="light" class="ml-1">standaard</b-badge>
               </span>
               <div v-if="row.local" class="text-nowrap">
                  <b-button size="sm" variant="outline-primary" class="mr-1" @click="startEdit(row)">
                     <b-icon icon="pencil" />
                  </b-button>
                  <b-button size="sm" variant="outline-danger" @click="deleteCategory(row)">
                     <b-icon icon="trash" />
                  </b-button>
               </div>
            </template>
         </b-list-group-item>
      </b-list-group>
      <small class="text-muted">{{ rows.length }} categorieën</small>
   </b-modal>
</template>
<script>

import db from "../db.js"

export default {
   name: "modal-manage-categories",
   props: ["userID", "categories"],
   data: function() {
      return {
         newCategoryName: "",
         newCategoryInvalidInfo: "",
         editingId: null,
         editingName: "",
      };
   },
   computed: {
      rows: function() {
         return this.categories.map(c => ({
            id: c.value.id,
            naam: c.value.naam,
            local: c.local === true,
         }))
      },
      newCategoryValid: function() {
         if(!this.newCategoryName) return null
         const naam = this.newCategoryName.trim()
         if(naam == "") return false
         const exists = this.categories.some(c => c.text && c.text.toLowerCase() == naam.toLowerCase())
         return !exists
      },
      now: function() {
         var date = new Date();
         return (
            String (date.getHours()) +
            String (date.getMinutes()) +
            String (date.getSeconds())
         )
      },
   },
   methods: {
      focusInput: function() {
         setTimeout(() => {
            if(this.$refs.inputNaam) this.$refs.inputNaam.focus()
         }, 500)
      },
      categoryId: function(naam) {
         return (naam
            .toLowerCase()
            .replace(/[^\w ]+/g, '')
            .replace(/ +/g, '-') + "-" + this.now)
      },
      addCategory: function() {
         const naam = this.newCategoryName.trim()
         if(naam == "") {
            this.newCategoryInvalidInfo = "Geef een naam op"
            return
         }
         if(this.newCategoryValid !== true) {
            this.newCategoryInvalidInfo = "Categorie bestaat al"
            return
         }
         const id = this.categoryId(naam)
         db.collection("users").doc(this.userID).collection("categories").doc(id)
            .set({ id: id, naam: naam })
            .then(() => { this.newCategoryName = "" })
            .catch(error => console.log(error))
      },
      startEdit: function(row) {
         this.editingId = row.id
         this.editingName = row.naam
      },
      saveEdit: function() {
         const naam = this.editingName.trim()
         if(naam == "") return
         db.collection("users").doc(this.userID).collection("categories").doc(this.editingId)
            .update({ naam: naam })
            .then(() => this.cancelEdit())
            .catch(error => console.log(error))
      },
      cancelEdit: function() {
         this.editingId = null
         this.editingName = ""
      },
      deleteCategory: function(row) {
         if(!confirm(`Weet je zeker dat je categorie '${row.naam}' wilt verwijderen? Bestaande boodschappen en ingrediënten behouden hun categorie.`)) return
         db.collection("users").doc(this.userID).collection("categories").doc(row.id)
            .delete()
            .catch(error => console.log(error))
      },
   },
}
</script>
